import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StoreService } from '../services/store/store.service';

@Injectable()
export class UnAuthorizedApiInterceptor implements HttpInterceptor {

  constructor(private _storeService: StoreService) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        // if (err.status === 401) {
        //   let currentSlug = this._storeService.currentSlug$.getValue();
        //   let redirect = '/shops'
        //   if(currentSlug){
        //     redirect = '/shop/' + currentSlug
        //   }
        //  //window.location.href = window.location.origin + redirect;
        //   return throwError(err);
        // } else {
        //   return throwError(err);
        // }
        return throwError(err);
      })
    );
  }
}
